import React, {useState} from "react";
import {useForm} from "react-hook-form";
import DealOfTheDayFields from "./DealOfTheDayFields";
import axios from "axios";

export default function () {
  const searchProduct = (val) => {
    let selectedProduct = getValues('product_id');
    return axios.get('best-selling-products/filter', {
      params: {keyword: val, product_id: selectedProduct, shop_id: getValues('shop_id')}})
      .then(res => {
        setData({...data, products: res.data?.products});
        return res.data?.products;
      });
  }

  const {register, handleSubmit, reset, control, watch, getValues} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const dealOfTheDayFields = <DealOfTheDayFields {...{register, errors, control, data, watch, searchProduct}} />;

  return {
    setErrors,
    dealOfTheDayFields,
    handleSubmit,
    reset,
    setData,
    searchProduct
  }
}